import { render, staticRenderFns } from "./BasePhase.vue?vue&type=template&id=850b3e2a&"
import script from "./BasePhase.vue?vue&type=script&lang=js&"
export * from "./BasePhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports